if (!customElements.get('speakon-home-moments')) {
  customElements.define('speakon-home-moments', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const track = this.querySelector('[data-track]');
      const cards = [...this.querySelectorAll('[data-card]')];
      const previous = this.querySelector('[data-step="-1"]');
      const next = this.querySelector('[data-step="1"]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      // Use the last card, not scrollWidth: descendant overflow can extend WebKit's scroll range.
      const maxScroll = () => cards.length ? Math.max(0,
        track.scrollLeft + cards[cards.length - 1].getBoundingClientRect().right - track.getBoundingClientRect().right + parseFloat(getComputedStyle(track).paddingRight)) : 0;
      const scrollTo = (left, behavior) => track.scrollTo({ left: Math.max(0, Math.min(left, maxScroll())), behavior });
      const update = () => {
        const end = maxScroll();
        if (track.scrollLeft > end + 1) scrollTo(end, 'instant');
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= end - 1;
      };
      track.addEventListener('scroll', update, { ...options, passive: true });
      this.resize = new ResizeObserver(update);
      this.resize.observe(track);
      update();

      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-step]');
        if (step && cards.length) {
          const distance = cards[0].offsetWidth + parseFloat(getComputedStyle(track).columnGap);
          scrollTo(track.scrollLeft + Number(step.dataset.step) * distance, reducedMotion.matches || event.detail === 0 ? 'instant' : 'smooth');
        }
        const trigger = event.target.closest('[data-open-story]');
        if (trigger) {
          const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
          dialog.toggleAttribute('data-keyboard', event.detail === 0);
          dialog.showModal();
          dialog.querySelector('.speakon-moments__dialog-body').scrollTop = 0;
          const video = dialog.querySelector('[data-phone-demo]');
          if (video) {
            video.controls = reducedMotion.matches;
            if (!reducedMotion.matches) video.play().catch(() => {
              if (dialog.open && !video.error) video.controls = true;
            });
          }
        }
        if (event.target.closest('[data-close-story]')) event.target.closest('dialog').close();
      }, options);

      // WebKit plays VP9 but drops its alpha channel; use Apple's HEVC alpha variant.
      const appleWebKit = /iPhone|iPad|iPod/.test(navigator.userAgent) ||
        (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1) ||
        (/Safari/.test(navigator.userAgent) && !/Chrome|Chromium|Edg|OPR|Android/.test(navigator.userAgent));
      this.querySelectorAll('dialog').forEach(dialog => {
        const video = dialog.querySelector('[data-phone-demo]');
        if (appleWebKit && video?.dataset.hevcSrc && video.canPlayType('video/mp4; codecs="hvc1"')) {
          video.src = video.dataset.hevcSrc;
        }
        dialog.addEventListener('click', (event) => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        }, options);
        dialog.addEventListener('close', () => dialog.querySelector('video')?.pause(), options);
      });
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-card]');
        if (card) scrollTo(track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left - parseFloat(getComputedStyle(track).paddingLeft), 'instant');
      }, options);
    }

    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      this.querySelectorAll('video').forEach(video => video.pause());
      this.events?.abort();
      this.resize?.disconnect();
    }
  });
}
